<template>
<section class="apply_box">
  <section class="apply_status"
    @click="applyDetail(item.id)"
    v-for="item in newApplyData.prkParkApplyLogBeans"
    :key="item.id"
  >
    <section class="status_top">
      <img src="../../../assets/images/icon_contract.png" />
      <p>{{item.applyStartDay | timeFormat}} 至 {{item.applyEndDay | timeFormat}}<span v-if="item.daoqi">即将到期</span></p>
      <template v-if="item.sendStatus == 2 || item.applyStatus == 0 ||item.applyStatus == 7">
        <span :class="['status',item.applyStatus == 3?'status_fail':'']" v-if="item.applyStatus != 2 && item.applyStatus != 4 && item.applyStatus != 7">{{item.applyStatus | applyStatus}}</span>
        <img v-else-if="item.applyStatus == 2" class="succ_icon" src="../../../assets/images/icon_take_effect.png">
        <img v-else-if="item.applyStatus == 7" class="succ_icon" src="../../../assets/images/icon_was_due.png">
        <img class="succ_icon" v-else src="../../../assets/images/icon_take_effectt.png">
      </template>
      <span v-else class="status">待提交</span>
    </section>
    <section class="status_center">
      <section class="center_item">
        <span class="item_left">月租费</span>
        <p class="item_right"><span>{{item.feeStandard}}</span> 元/月</p>
      </section>
      <section class="center_item">
        <span class="item_left">申请人</span>
        <p class="item_right">{{applyData.userName}}</p>
      </section>
      <section class="center_item card_item">
        <span class="item_left">车牌号</span>
        <section class="card_list">
          <p :class="['card_number',item.length==9?'card_number_x':'']" v-for="card in item.cardList" :key="card">{{card}}</p>
        </section>
      </section>
      <section class="center_item card_item" v-if="item.reason">
        <span class="item_left item_left_red">拒绝理由</span>
        <p class="item_right item_right_reason">{{item.reason}}</p>
      </section>
    </section>
    <section :class="[item.sendStatus == 2&& item.applyStatus ==2 && newApplyData.startDay ?'status_bottom1':'status_bottom']">
      <!-- sendStatus=2 发送审批流成功 -->

      <template v-if="item.sendStatus == 2 || item.applyStatus == 0">
        <span @click.stop="delectContract(item)" v-if="item.applyStatus == 4 || item.applyStatus == 3" class="btn_primary">删除</span>
        <span v-else class="btn_primary">查看详情</span>
      </template>
      <span v-else class="btn_primary btn_apply" @click.stop="repeatApply">提交申请</span>
    </section>
    <div class="tiems" v-if="item.sendStatus == 2 && item.applyStatus ==2  && newApplyData.startDay">
       <div class="tiems_div1">
          <span class="times_span">支付倒计时:</span>
          <span class="times_span">{{item.stime}}</span>
       </div>
       <div class="tiems_div2">
          <span class="times_span2">{{'请尽快缴费 ，审合通过后'+newApplyData.paymentCountdown+'小时内未缴费将取消申请资格！'}}</span>
       </div>
    </div>
     <div class="tiems1" v-if="item.sendStatus == 2 && item.applyStatus ==7">
       <div class="tiems_div2">
          <span class="times_span">失效原因: {{newApplyData.reason}}</span>
       </div>
    </div>
  </section>
</section>
</template>

<script>
var timeout = '';
export default {
  props:{
    applyData:{
      type:Object,
      default:()=>{}
    }
  },
  watch: {
    applyData() {
        this.startTime();
    }
  },
  data(){
    return {
       allTime:0,
       htime:0,
       mtime:0,
       stime:0,
    }
  },
  computed:{
    newApplyData(){
      let d = this.applyData || [];
      if(!d.paymentCountdown){
         d.paymentCountdown =24;
      }
      if(d.prkParkApplyLogBeans){
        d.prkParkApplyLogBeans.forEach(item=>{
          // 如果结束时间减当前时间小于30天,提示即将到期
          if(
            new Date(item.applyEndDay.replace(/\./g,'/')).getTime()-new Date().getTime()<24*60*60*30*1000 &&
            new Date(item.applyEndDay.replace(/\./g,'/')).getTime()-new Date().getTime() > 0 &&
            item.applyStatus == 2
          ){
            item.daoqi = true
          }
          if(item.plateNo){
            item.cardList = item.plateNo.split(",").filter(item=>item && item.trim());
            let newL = item.cardList.map(cur=>{
             return cur.slice(0,2)+'·'+cur.slice(2)
            })
            item.cardList = newL
          }
        })
        return d
      }else{
        return {}
      }
    }
  },
  filters:{
    applyStatus(val){
      if(val == '0'){
        return '等待候补中'
      }else if(val== '1'){
        return '审批中'
      }else if(val == '3'){
        return '审批失败'
      }else if(val == '4'){
        return '已解绑'
      }else if(val == '7'){
        return '已失效'
      }else{
        return '已解绑'
      }
    },
    timeFormat(val){
      if(val){
        return val.split(" ")[0]
      }else{
        return ''
      }
    }
  },
  created(){
    this.startTime()
  },
  unmounted () {
    clearTimeout(timeout);
  },
  beforeDestroy() {
      //清除定时器
      clearTimeout(timeout);
      console.log("beforeDestroy");
  },
  destroyed() {
      //清除定时器
      //clearInterval(this.timer);
      console.log("destroyed");
  },
  methods:{
    startTime(){
      clearTimeout(timeout)
     // console.log("in startTime")
      // var minutes = parseInt(leftTime / 60 % 60, 10); // 计算剩余的分钟
      // var seconds = parseInt(leftTime % 60, 10); // 计算剩余的秒数
      var hasnext = false;
      var nowDate = new Date();
      var nowTime = nowDate.getTime();
      for(var i=0;i<this.newApplyData.prkParkApplyLogBeans.length;i++){
         var item = this.newApplyData.prkParkApplyLogBeans[i];
         if(item.sendStatus==2 && item.applyStatus==2 && this.newApplyData.endPaymentTime && this.newApplyData.startDay){
            var aTime =this.newApplyData.endPaymentTime -nowTime;
            // console.log("in startTime aTime ===  " + aTime)
            if(aTime>0){
                var h = parseInt(aTime/(1000*60*60))
                var ms = aTime%(1000*60*60)
                var m = parseInt(ms/(1000*60))
                var ss = ms%(1000*60)
                var s = parseInt(ss/1000);
                // console.log("in startTime hh====  " + h)
                // console.log("in startTime mm====  " + m)
                // console.log("in startTime ss====  " + s)
                if(h<10){
                  h="0"+h
                }
                 if(m<10){
                  m="0"+m
                }
                 if(s<10){
                  s="0"+s
                }
                item.stime =h+":"+m+":"+s;
                hasnext =true;
                // this.newApplyData.prkParkApplyLogBeans = JSON.s
            }else{
                item.applyStatus =7
            }
            // console.log(this.newApplyData.prkParkApplyLogBeans[0].stime)
            this.newApplyData.prkParkApplyLogBeans = JSON.parse(JSON.stringify(this.newApplyData.prkParkApplyLogBeans))
            this.newApplyData = JSON.parse(JSON.stringify(this.newApplyData))
         }

      }
      // minutes = this.checkTime(minutes);
      // seconds = this.checkTime(seconds);
      if (hasnext) {
        timeout = setTimeout(() => {
          this.startTime()
        }, 1000)
      }
    },
    applyDetail(id){
      this.$router.push("/parkingApplyDetail?id="+this.applyData.parkHeaderId+"&applyId="+id)
    },
    delectContract(item){
      this.$emit("delectContract",item)
    },
    repeatApply(){
      this.$emit("repeatApply")
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../../assets/css/common.less";
.apply_box{
  overflow:hidden;
  margin-top:14px;
  position: relative;
}
.tiems{
  position: absolute;
  left: 28px;
  bottom:0px;
  flex-direction: column;
  // align-items: center;
  height: 168px;
  display: flex;
  // width: 300px;
  // background-color: red;
}
.tiems1{
  position: absolute;
  left: 28px;
  bottom:0px;
  flex-direction: row;
  align-items: center;
  height: 88px;
  display: flex;
}
.tiems_div1{
   margin-top: 24px;
  flex-direction: row;
  margin-bottom: 8px;
}
.tiems_div2{
  flex-direction: row;
}
.times_span{
  // margin-top: 26px;
  height:40px;
  font-size:28px;
  font-weight:400;
  color:rgba(253,156,65,1);
  line-height:40px;
  margin-right: 10px;
}
.times_span2{
  width:526px;
  // height:72px;
  display: flex;
  font-size:26px;
  font-weight:400;
  color:#666666;
  line-height:36px;

}
.apply_status{
  background:#fff;
  margin-bottom:14px;
  position: relative;
  .status_top{
    height:88px;
    padding:0 28px;
    .flex();
    align-items: center;
    img{
      width:44px;
      height:44px;
      margin-right:10px;
    }
    .succ_icon{
      position: absolute;
      width:124px;height:124px;
      top:20px;right:20px;
    }
    p{
      flex:1;
      .flex();
      align-items: center;
      font-size:28px;
      color:rgba(51,51,51,1);
      span{
        display:inline-block;
        height:40px;
        line-height:40px;
        padding:0 10px;
        border-radius: 20px;
        background:#fd9838;
        color:#fff;
        font-size:24px;
        margin-left:20px;
      }
    }
    .status{
      font-size:26px;
      color:rgba(253,152,56,1);
    }
    .status_fail{
      color:#fc3f56;
    }
  }
  .status_center{
    padding:28px 28px 0;
    background:#fafafa;
    .flex();
    flex-wrap: wrap;
    .center_item{
      width:50%;
      .flex();
      // align-items: center;
      margin-bottom:28px;
      .item_left{
        width:124px;
        font-size:28px;
        line-height: 44px;
        color:rgba(153,153,153,1);
      }
      .item_left_red{
        color:#FC3F56;
        font-size:26px;
      }
      .item_right{
        color:#333;
        font-size:28px;
        line-height: 44px;
        flex:1;
        word-break:break-all;
        span{
          color:#fc3f56;
          display: inline-block;
          margin-right:8px;
          font-weight:bold;
        }
      }
      .item_right_reason{
        font-size:26px;
      }
      .card_number{
        height:44px;
        background:rgba(0,135,255,1);
        border-radius:4px;
        padding:0 8px;
        line-height: 44px;
        color:#fff;
        font-size:28px;
        margin-right:10px;
        margin-bottom:10px;
      }
      .card_number_x{
        background:linear-gradient(180deg,rgba(235,255,249,1) 0%,rgba(134,223,193,1) 100%);
        color:#333;
      }
    }
    .card_item{
      width:100%;
      margin-bottom:18px;
      .card_list{
        .flex();
        flex-wrap: wrap;
        flex:1;
      }
    }
  }
  .status_bottom{
    .flex();
    justify-content: flex-end;
    padding:18px 28px;
    .btn_primary{
      margin-left:20px;
      display:block;
      width:128px;
      height:52px;
      line-height:52px;
      border-radius:4px;
      .border();
      text-align: center;
      font-size:26px;
      color:#666;
    }
    .btn_apply{
      .border(#1740DA);
      color:#fff;
      background:#1740DA;
    }
  }
}
.status_bottom1{
    .flex();
   justify-content: flex-end;
   padding:54px 28px;
   .btn_primary{
      margin-left:20px;
      display:block;
      width:128px;
      height:52px;
      line-height:52px;
      border-radius:4px;
      .border();
      text-align: center;
      font-size:26px;
      color:#666;
    }
    .btn_apply{
      .border(#1740DA);
      color:#fff;
      background:#1740DA;
    }
}
</style>
